"use client";

import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { cn } from "~/lib/utils";

interface CodeBlockProps {
    code: string;
    className?: string;
    enableCopy?: boolean;
}

export function CodeBlock({
    code,
    className,
    enableCopy = true,
}: CodeBlockProps) {
    const [copied, setCopied] = useState(false);

    async function handleCopy() {
        await navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    }

    return (
        <div className={cn("group relative", className)}>
            <pre className="max-h-72 overflow-auto rounded-lg border bg-muted p-4 text-xs leading-relaxed">
                <code className="font-mono text-foreground">{code}</code>
            </pre>
            {enableCopy && (
                <button
                    type="button"
                    onClick={handleCopy}
                    aria-label="Copy code"
                    className={cn(
                        "absolute right-2 top-2 flex items-center justify-center rounded-md border bg-background p-1.5 transition-colors hover:bg-muted",
                        copied && "border-primary/40 text-primary",
                    )}
                >
                    {copied ? (
                        <Check className="size-3.5" />
                    ) : (
                        <Copy className="size-3.5" />
                    )}
                </button>
            )}
        </div>
    );
}
